import get from 'lodash/get';

export function renderCaptcha(apiKey?: string): Promise<void> {
  const container = document.getElementById('captcha-root');

  const customCaptchaStyles = `
      p, div {
        font-family: "Roboto Flex", Verdana, Geneva, Tahoma, sans-serif;
        font-size: 20px;
        margin-top: 0;
      }
      #root {
        background-color: rgb(255, 255, 255);
        border-radius: 8px;
        margin-left: -10px;
        padding: 10px;
      }
    `;

  if (!container || !window.awsWafCookieDomainList || !apiKey) {
    return Promise.reject(new Error('AWS Captcha was requested but dependencies are missing'));
  }

  return new Promise((resolve, reject) => {
    const cleanUp = () => {
      setTimeout(() => {
        container.classList.remove('active');
        container.replaceChildren();
      }, 3000);
    };
    const onLoad = () => {
      container.classList.add('active');
      const root = get(container, 'children[0].shadowRoot');
      const sheet = new CSSStyleSheet();
      sheet.replaceSync(customCaptchaStyles);
      if (root) root.adoptedStyleSheets.push(sheet);
    };
    const onError = () => {
      cleanUp();
      reject(new Error('Error processing captcha'));
    };
    const onSuccess = () => {
      cleanUp();
      resolve();
    };

    window.AwsWafCaptcha?.renderCaptcha(container, {
      apiKey,
      onLoad,
      onPuzzleIncorrect: () => {},
      onSuccess,
      onError,
      skipTitle: true
    });
  });
}
